import { useState, useContext } from 'react';
import ethereumLogo from '../assets/ethereum-logo1.svg'; 
import scrollLogo from '../assets/scroll-logo.png';
import { AuthContext } from "../../contexts/AuthContext"; 

const NFTAccessSection = () => {
  const authContext = useContext(AuthContext); // Access authContext directly
  const [selectedNetwork, setSelectedNetwork] = useState(
    localStorage.getItem('selectedNetwork') || 'mainnet'
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const options = [
    { value: 'mainnet', label: 'Mainnet', logo: ethereumLogo },
    { value: 'scroll', label: 'Scroll', logo: scrollLogo },
  ];

  const handleNetworkChange = (value) => {
    setSelectedNetwork(value);
    localStorage.setItem('selectedNetwork', value);
    setIsDropdownOpen(false); // Close the dropdown
  };

  return (
    <div className="flex items-center space-x-2">
      {/* NFT Access Button */}
      <button
        className="font-semibold text-gray-700"
        style={{ color: 'var(--text-color)' }}
        onClick={authContext.NFTaccess} // Call NFTaccess from context
      >
        NFTaccess
      </button>

      {/* Separator */}
      <span className="text-gray-700">|</span>

      {/* Dropdown Section */}
      <div className="relative">
        {/* Selected Network */}
        <button
          className="flex items-center  py-1 cursor-pointer"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <img
            src={
              selectedNetwork === 'mainnet'
                ? ethereumLogo
                : scrollLogo
            }
            alt="Network Logo"
            className="w-3 h-4"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-3 text-gray-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {/* Dropdown Menu */}
        {isDropdownOpen && (
          <div className="absolute mt-2 w-40 bg-white border border-gray-300 rounded shadow-lg">
            {options.map((option) => (
              <div
                key={option.value}
                onClick={() => handleNetworkChange(option.value)}
                style={{ color: 'var(--text-color)' }}
                className="flex items-center space-x-2 px-2 py-1 cursor-pointer hover:bg-gray-100"
              >
                <img src={option.logo} alt={option.label} className="w-6 h-6" />
                <span className="text-gray-700">{option.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NFTAccessSection;
